import { useEffect, useState } from 'react';

const useTimer = (timerSpeed: number) => {
    const [ initialTimeInSeconds, setInitialTimeInSeconds ] = useState(0);
    const now = () => Math.floor(Date.now() / 1000);    

    useEffect(() => {
        setInitialTimeInSeconds(now());
    }, []);
    
    const getPercentage = () => {
        const currentSecondDiff = now() - initialTimeInSeconds;
        const totalSeconds = timerSpeed / 3.25;
        const idealPercentage = Math.floor(currentSecondDiff / totalSeconds * 100);

        return idealPercentage > 100 ? 100 : idealPercentage;
    };

    return [ getPercentage ];
};

export default useTimer;